<script lang="ts">
	import type { ComponentSizes } from '../types/props';
	import SVG from '$lib/elements/SVG.svelte';

	let tooltipObj = {};

	export let iconName: string | null = null;
	export let active = false;
	export let tooltipTitle: string | null = null;
	export let tooltipPosition: string | null = null;
	export let classNames: string | null = null;
	export let handleMouseEnter: () => void = null;
	export let handleMouseLeave: () => void = null;
	export let size: ComponentSizes = 'default';
	export let disabled: boolean = false;

	$: tooltipObj = { title: tooltipTitle, placement: tooltipPosition ?? 'top' };
</script>

<SVG
	outlined={!active}
	name={iconName}
	{disabled}
	on:click
	classNames="cursor-pointer {classNames}"
	tooltip={tooltipObj}
	{handleMouseEnter}
	{handleMouseLeave}
	{size}
/>
